import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export function getIsAreaParts(offer: IOfferSchema): boolean {
  return !!offer.areaParts?.length;
}
